module.exports = __webpack_public_path__ + "media/img/files/file-1-5f09160e3d9f9adb0c4aed4d04d44dcc.jpg";